import React, { useCallback } from 'react'
import { hooks, ModelForm } from '@front/volcanion'

import Callbacks from './callbacks'

const withForm = Component => props => {
  const { user_id } = hooks.useParams()
  const [handleWelcomeAction] = hooks.useModelFunction('stage', 'handleWelcomeAction')
  const requestSubmitOrderLimit = hooks.useGlobalFormFunction('userorderlimit_list', 'requestSubmit')
  const [, { openDialog }] = hooks.useDialogs()

  const formProps = {
    name: 'user_form',
    model_name: 'user',
    record_id: user_id,
    related_states: [],
    related_searches: [],
    getEmptyForm: useCallback(Callbacks.getEmptyFormHandler(), []),
    recordToForm: useCallback(Callbacks.recordToFormHandler(), []),
    recordToState: useCallback(Callbacks.recordToStateHandler(), []),
    formToRecord: useCallback(Callbacks.formToRecordHandler(), []),
    formToOptions: useCallback(Callbacks.formToOptionsHandler(), []),
    onSubmitSuccess: useCallback(Callbacks.onSubmitSuccessHandler(handleWelcomeAction, requestSubmitOrderLimit), [handleWelcomeAction, requestSubmitOrderLimit]),
    onSubmitFailed: useCallback(Callbacks.onSubmitFailedHandler(openDialog), [openDialog]),
    getFailedNotification: useCallback(Callbacks.getFailedNotificationHandler(), []),
    populate: [
      'auth',
      'info',
      'preference',
      'customerinfo.driver_options',
      'customerinfo.vehicle_options',
      'customerinfo.customer_billed_id.info',
      'customerinfo.customer_billed_id.customerinfo',
    ],
    initialState: { isReadOnly: !!user_id },
    submitChangesOnly: false
  }

  const mergedProps = {
  }

  return (
    <ModelForm {...formProps}>
      <Component {...mergedProps} />
    </ModelForm>
  )
}

export default withForm
